// actions/religionActions.js
// BUG FIX: this used a standalone axios instance (cookie-only auth),
// unlike the rest of the app's action files which use createApi() from
// utils/apiClient — that shared client also attaches the JWT as a
// Bearer header from localStorage, which is what makes auth work inside
// Capacitor (mobile) and Electron, where cross-origin cookies are
// unreliable/don't persist. Without it, every call in this file would
// silently 401 on mobile/desktop (web was fine, since cookies work
// there).
import createApi from "../utils/apiClient";
const api = createApi();

export const getAllReligions =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "ALL_RELIGIONS_REQUEST" });
      const { data } = await api.get("/religions", { params });
      dispatch({ type: "ALL_RELIGIONS_SUCCESS", payload: data.religions });
    } catch (err) {
      dispatch({
        type: "ALL_RELIGIONS_FAIL",
        payload: err.response?.data?.message,
      });
    }
  };

// Admin "Pending Approval" tab
export const getPendingReligions = () => async (dispatch) => {
  try {
    dispatch({ type: "PENDING_RELIGIONS_REQUEST" });
    const { data } = await api.get("/religions/pending");
    dispatch({
      type: "PENDING_RELIGIONS_SUCCESS",
      payload: data.religions,
    });
  } catch (err) {
    dispatch({
      type: "PENDING_RELIGIONS_FAIL",
      payload: err.response?.data?.message,
    });
  }
};

export const createReligion = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "CREATE_RELIGION_REQUEST" });
    const { data } = await api.post("/religions", payload);
    dispatch({ type: "CREATE_RELIGION_SUCCESS", payload: data.religion });
    return data;
  } catch (err) {
    dispatch({
      type: "CREATE_RELIGION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Called from the Add Staff form's "+ type a new value" option.
// Saves as "pending" — does NOT show up in dropdowns until approved.
export const suggestReligion = (name, parent_id) => async (dispatch) => {
  try {
    dispatch({ type: "SUGGEST_RELIGION_REQUEST" });
    const { data } = await api.post("/religions/suggest", { name, parent_id });
    dispatch({ type: "SUGGEST_RELIGION_SUCCESS", payload: data.religion });
    return data;
  } catch (err) {
    dispatch({
      type: "SUGGEST_RELIGION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const approveReligion = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/religions/${id}/approve`);
    dispatch({ type: "APPROVE_RELIGION_SUCCESS", payload: data.religion });
    return data;
  } catch (err) {
    dispatch({
      type: "APPROVE_RELIGION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const rejectReligion = (id, reason) => async (dispatch) => {
  try {
    const { data } = await api.put(`/religions/${id}/reject`, { reason });
    dispatch({ type: "REJECT_RELIGION_SUCCESS", payload: data.religion });
    return data;
  } catch (err) {
    dispatch({
      type: "REJECT_RELIGION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const updateReligion = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_RELIGION_REQUEST" });
    const { data } = await api.put(`/religions/${id}`, payload);
    dispatch({ type: "UPDATE_RELIGION_SUCCESS", payload: data.religion });
    return data;
  } catch (err) {
    dispatch({
      type: "UPDATE_RELIGION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

export const deleteReligion = (id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_RELIGION_REQUEST" });
    const { data } = await api.delete(`/religions/${id}`);
    dispatch({ type: "DELETE_RELIGION_SUCCESS", payload: id });
    return data;
  } catch (err) {
    dispatch({
      type: "DELETE_RELIGION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// A rejected entry can be resubmitted — resets it back to "pending" so it
// shows up in the Approvals queue again.
export const resubmitReligion = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/religions/${id}/resubmit`);
    dispatch({ type: "RESUBMIT_RELIGION_SUCCESS", payload: data.religion });
    return data;
  } catch (err) {
    dispatch({
      type: "RESUBMIT_RELIGION_FAIL",
      payload: err.response?.data?.message,
    });
    throw err;
  }
};

// Rejected list — shown on the Approvals page so admin/requester can
// review the reason and Resubmit if needed. Stored separately from the
// active dropdown list (state.religion.rejected) to avoid clobbering it.
export const getRejectedReligions = () => async (dispatch) => {
  try {
    const { data } = await api.get("/religions", {
      params: { status: "rejected" },
    });
    dispatch({ type: "REJECTED_RELIGIONS_SUCCESS", payload: data.religions });
  } catch (err) {
    dispatch({
      type: "REJECTED_RELIGIONS_FAIL",
      payload: err.response?.data?.message,
    });
  }
};
